import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type JobStateFragment = { id: string, jobScheduleId: string, status: Types.JobEntityStatusEnum, purpose?: Types.JobPurposeEnum | null, input?: { surveyExportInput?: string | null, chartExportInput?: { chartId: string } | null, reportExportInput?: { reportId: string } | null, reportMediaExportInput?: { reportId: string } | null, userSurveyResponseExportInput?: { filters: { parentEntityIds?: Array<string> | null } } | null, bulkUnAssignContentPropsInput?: { entityId: string, userIds?: Array<string> | null, learnerGroupIds?: Array<string> | null } | null, forceCompleteContentInput?: { userIds: Array<string>, entityIds: Array<string> } | null, employeeJourneyReportsExportInput?: { employeeJourneyId: string } | null } | null, meta?: { bulkTagsUpdateMetadata?: { updatedTagsCount: number, createdTagsCount: number } | null, userGroupMemberImportMetadata?: { createdGroupsCount: number, updatedGroupsCount: number } | null, userGroupImportMetadata?: { groupIds: Array<string> } | null, learnerImportMetadata?: { createdUsersCount: number, updatedUsersCount: number, mergedUsersCount?: number | null } | null, questionImportMetadata?: { createdQuestionsCount: number } | null, learnerExportMetadata?: { totalCount: number, exportedCount: number } | null, questionsExportMetadata?: { totalCount: number, exportedCount: number } | null, tagExportMetadata?: { totalCount: number, exportedCount: number } | null, groupMemberExportMetadata?: { totalCount: number, exportedCount: number } | null, taggedEntitiesExportMetadata?: { totalCount: number, exportedCount: number } | null, offlineEventAttendanceImportMetadata?: { updatedUsersCount: number } | null, offlineEventAttendanceExportMetadataType?: { totalCount: number, exportedCount: number } | null, assignmentImportMetadataType?: { createdAssignmentsCount: number } | null, quizQuestionImportMetadata?: { createdQuestionsCount: number } | null, chartExportMetadata?: { totalCount: number, exportedCount: number } | null, reportExportMetadata?: { totalCount: number, exportedCount: number } | null, reportMediaExportMetadata?: { totalCount: number, exportedCount: number } | null, scormImportMetadata?: { schemaVersion?: string | null, resourceHref?: string | null, masteryScore?: number | null } | null, surveyExportMetadata?: { totalCount: number, exportedCount: number } | null, skillsImportMetadata?: { createdSkillsCount: number } | null, assignmentLearnerImportMetadata?: { userIds: Array<string>, userGroupId?: string | null } | null, userSurveyResponseExportMetadata?: { totalCount: number, exportedCount: number } | null, bulkUnAssignLearnerMetadata?: { unAssignableLearnersCount: number, totalLearnersCount: number } | null, aiCourseCreatorMetadataType?: { completedStep: number, maxSteps?: number | null, contentId: string } | null } | null, outputMediaUrls: Array<{ url: string, format: string, fileName?: string | null }> };


export type JobStateFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const JobStateFragmentDoc = /*#__PURE__*/ gql`
    fragment JobState on JobType {
  id
  jobScheduleId
  status
  purpose
  input {
    chartExportInput {
      chartId
    }
    reportExportInput {
      reportId
    }
    reportMediaExportInput {
      reportId
    }
    userSurveyResponseExportInput {
      filters {
        parentEntityIds
      }
    }
    surveyExportInput
    bulkUnAssignContentPropsInput {
      entityId
      userIds
      learnerGroupIds
    }
    forceCompleteContentInput {
      userIds
      entityIds
    }
    employeeJourneyReportsExportInput {
      employeeJourneyId
    }
  }
  meta {
    bulkTagsUpdateMetadata {
      updatedTagsCount
      createdTagsCount
    }
    userGroupMemberImportMetadata {
      createdGroupsCount
      updatedGroupsCount
    }
    userGroupImportMetadata {
      groupIds
    }
    learnerImportMetadata {
      createdUsersCount
      updatedUsersCount
      mergedUsersCount
    }
    questionImportMetadata {
      createdQuestionsCount
    }
    learnerExportMetadata {
      totalCount
      exportedCount
    }
    questionsExportMetadata {
      totalCount
      exportedCount
    }
    tagExportMetadata {
      totalCount
      exportedCount
    }
    groupMemberExportMetadata {
      totalCount
      exportedCount
    }
    taggedEntitiesExportMetadata {
      totalCount
      exportedCount
    }
    offlineEventAttendanceImportMetadata {
      updatedUsersCount
    }
    offlineEventAttendanceExportMetadataType {
      totalCount
      exportedCount
    }
    assignmentImportMetadataType {
      createdAssignmentsCount
    }
    quizQuestionImportMetadata {
      createdQuestionsCount
    }
    chartExportMetadata {
      totalCount
      exportedCount
    }
    reportExportMetadata {
      totalCount
      exportedCount
    }
    reportMediaExportMetadata {
      totalCount
      exportedCount
    }
    scormImportMetadata {
      schemaVersion
      resourceHref
      masteryScore
    }
    surveyExportMetadata {
      totalCount
      exportedCount
    }
    skillsImportMetadata {
      createdSkillsCount
    }
    assignmentLearnerImportMetadata {
      userIds
      userGroupId
    }
    userSurveyResponseExportMetadata {
      totalCount
      exportedCount
    }
    bulkUnAssignLearnerMetadata {
      unAssignableLearnersCount
      totalLearnersCount
    }
    aiCourseCreatorMetadataType {
      completedStep
      maxSteps
      contentId
    }
  }
  outputMediaUrls {
    url
    format
    fileName
  }
}
    `;